var map = {
	"./Server-Busy.None.svg": 2301,
	"./Server-Busy.OfflineDrop.svg": 2302,
	"./Server-Busy.Ssh.svg": 2303,
	"./Server-Busy.TentacleActive.svg": 2304,
	"./Server-Busy.TentaclePassive.svg": 2305,
	"./Server-CalamariNeedsUpgrade.Ssh.svg": 2306,
	"./Server-CalamariNeedsUpgrade.TentacleActive.svg": 2307,
	"./Server-CalamariNeedsUpgrade.TentaclePassive.svg": 2308,
	"./Server-Default.AzureCloudService.svg": 2309,
	"./Server-Default.AzureServiceFabricCluster.svg": 2310,
	"./Server-Default.AzureSubscription.svg": 2311,
	"./Server-Default.AzureWebApp.svg": 2312,
	"./Server-Default.Ftp.svg": 2313,
	"./Server-Default.Kubernetes.svg": 2314,
	"./Server-Default.None.svg": 2315,
	"./Server-Default.OfflineDrop.svg": 2316,
	"./Server-Default.Ssh.svg": 2317,
	"./Server-Default.TentacleActive.svg": 2318,
	"./Server-Default.TentaclePassive.svg": 2319,
	"./Server-Disabled.AzureCloudService.svg": 2320,
	"./Server-Disabled.AzureServiceFabricCluster.svg": 2321,
	"./Server-Disabled.AzureSubscription.svg": 2322,
	"./Server-Disabled.AzureWebApp.svg": 2323,
	"./Server-Disabled.Ftp.svg": 2324,
	"./Server-Disabled.Kubernetes.svg": 2325,
	"./Server-Disabled.None.svg": 2326,
	"./Server-Disabled.OfflineDrop.svg": 2327,
	"./Server-Disabled.Ssh.svg": 2328,
	"./Server-Disabled.TentacleActive.svg": 2329,
	"./Server-Disabled.TentaclePassive.svg": 2330,
	"./Server-HasWarnings.Ssh.svg": 2331,
	"./Server-HasWarnings.TentacleActive.svg": 2332,
	"./Server-HasWarnings.TentaclePassive.svg": 2333,
	"./Server-Healthy.AzureCloudService.svg": 2334,
	"./Server-Healthy.AzureServiceFabricCluster.svg": 2335,
	"./Server-Healthy.AzureSubscription.svg": 2336,
	"./Server-Healthy.AzureWebApp.svg": 2337,
	"./Server-Healthy.Ftp.svg": 2338,
	"./Server-Healthy.Kubernetes.svg": 2339,
	"./Server-Healthy.None.svg": 2340,
	"./Server-Healthy.OfflineDrop.svg": 2341,
	"./Server-Healthy.Ssh.svg": 2342,
	"./Server-Healthy.TentacleActive.svg": 2343,
	"./Server-Healthy.TentaclePassive.svg": 2344,
	"./Server-NeedsUpgrade.TentacleActive.svg": 2345,
	"./Server-NeedsUpgrade.TentaclePassive.svg": 2346,
	"./Server-Unavailable.AzureCloudService.svg": 2347,
	"./Server-Unavailable.AzureServiceFabricCluster.svg": 2348,
	"./Server-Unavailable.AzureSubscription.svg": 2349,
	"./Server-Unavailable.AzureWebApp.svg": 2350,
	"./Server-Unavailable.Ftp.svg": 2351,
	"./Server-Unavailable.Kubernetes.svg": 2352,
	"./Server-Unavailable.OfflineDrop.svg": 2353,
	"./Server-Unavailable.Ssh.svg": 2354,
	"./Server-Unavailable.TentacleActive.svg": 2355,
	"./Server-Unavailable.TentaclePassive.svg": 2356,
	"./Server-Unhealthy.AzureCloudService.svg": 2357,
	"./Server-Unhealthy.AzureServiceFabricCluster.svg": 2358,
	"./Server-Unhealthy.AzureWebApp.svg": 2359,
	"./Server-Unhealthy.Kubernetes.svg": 2360,
	"./Server-Unhealthy.OfflineDrop.svg": 2361,
	"./Server-Unhealthy.Ssh.svg": 2362,
	"./Server-Unhealthy.TentacleActive.svg": 2363,
	"./Server-Unhealthy.TentaclePassive.svg": 2364,
	"./Server-Unknown.AzureCloudService.svg": 2365,
	"./Server-Unknown.AzureServiceFabricCluster.svg": 2366,
	"./Server-Unknown.AzureSubscription.svg": 2367,
	"./Server-Unknown.AzureWebApp.svg": 2368,
	"./Server-Unknown.Ftp.svg": 2369,
	"./Server-Unknown.Kubernetes.svg": 2370,
	"./Server-Unknown.None.svg": 2371,
	"./Server-Unknown.OfflineDrop.svg": 2372,
	"./Server-Unknown.Ssh.svg": 2373,
	"./Server-Unknown.TentacleActive.svg": 2374,
	"./Server-Unknown.TentaclePassive.svg": 2375,
	"./Server-Warning.OfflineDrop.svg": 2376
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2300;